<template>
  <div>
    <v-btn
      v-if="order.status == 'writing'"
      color="warning"
      block
      depressed
      small
      @click="confirmOrDeliverOrder"
    >
      <span class="font-weight-bold">納品する</span>
    </v-btn>
    <v-dialog v-model="confirmDialog" width="500">
      <v-card>
        <v-container>
          <v-row>
            <v-card-text class='pb-0'>
              本当に納品しますか？<br>
              納品すると記事が編集できなくなります。
              <v-checkbox
                v-model="notShowDeliverOrderDialog"
                label="以後、この確認ダイアログを表示しない。"
              ></v-checkbox>
            </v-card-text>
          </v-row>
          <v-row>
            <v-col class='pt-0'>
              <v-btn
                block
                depressed
                small
                @click="confirmDialog = false"
              >
                <span class="font-weight-bold">キャンセル</span>
              </v-btn>
            </v-col>
            <v-col class='pt-0'>
              <v-btn
                color="warning"
                block
                depressed
                small
                @click="clickDeliverOrderBtn"
              >
                <span class="font-weight-bold">納品する</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      confirmDialog: false,
      notShowDeliverOrderDialog: false
    }
  },
  methods: {
    confirmOrDeliverOrder () {
      if (localStorage.getItem('notShowDeliverOrderDialog') === 'true') {
        this.deliverOrder()
      } else {
        this.confirmDialog = true
      }
    },
    clickDeliverOrderBtn () {
      if (this.notShowDeliverOrderDialog === true) {
        localStorage.setItem('notShowDeliverOrderDialog', true)
      }
      this.deliverOrder()
    },
    async deliverOrder () {
      try {
        this.$store.dispatch('LoaderStore/displayLoader')
        await this.$store.dispatch('PostEditor/deliverOrder', this.order.id)
        this.fetchPost()
      } finally {
        this.$store.dispatch('LoaderStore/hideLoader')
      }
    },
    fetchPost () {
      const query = {
        postId: location.pathname
          .match(/\/posts\/\d*/)[0]
          .replace(/\/posts\//, '')
      }
      this.$store.dispatch('PostEditor/fetchPost', query)
    }
  }
}
</script>
